// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServerErrorPage_wrapper__3O5-c","title":"ServerErrorPage_title__1a0o8","description":"ServerErrorPage_description__KxVK7","button":"ServerErrorPage_button__1m2EU"};